import { UtenteVO } from "./utenteVO";

export class ProcedimentoVO {
  codice: string;
  nome: string;
  output: string;
  responsabile: UtenteVO;
}
